import axios from 'axios'
import decrypt from './decrypt'

require('./interceptors')

export class Jwt {
    static accessToken (email, password) {
        let response = JSON.parse(localStorage.getItem('response')) 
        let urlsApi = response ? response.Empresas[localStorage.getItem('INDEXEMPRESA')].api : ''

        let descpass = decrypt.descriptografar(password)
        return axios.post(urlsApi + 'login', {email: email, password: descpass})
    }
}


// WEBPACK FOOTER //
// ./src/services/resources.js